
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 95 95"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"47.5","cy":"47.5","r":"38.79","fill":"#fff"}}),_c('path',{attrs:{"d":"M70.31 54.01H53.98V70.3c0 2.52-4 4.62-6.48 4.62-1.26 0-4.27-.52-5.11-1.36a4.62 4.62 0 01-1.34-3.26V54.01H24.7a4.61 4.61 0 01-3.26-1.36c-.84-.85-1.37-3.85-1.37-5.12-.02-2.52 2.1-6.52 4.63-6.52h16.35V24.69c0-2.52 4-4.62 6.47-4.62S54 22.17 54 24.69v16.32h17.31c2.52 0 3.62 4 3.62 6.48s-2 6.52-4.62 6.52zM47.5.01A47.5 47.5 0 1095.05 47.5 47.54 47.54 0 0047.5.01z"}})])
          )
        }
      }
    